import { PersonalMessageParagraphT } from 'types/shared/core/Post';
import { Box, Button, Stack, styled, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

type PostContentPersonalMessagePropsT = {
  paragraph: PersonalMessageParagraphT;
  onPersonalMessageClick?: (paragraph: PersonalMessageParagraphT) => void;
};

const StyledPersonalMessageParagraph = styled('div')<{}>`
  padding: 0px 0px;
  & > div {
    padding: 16px;
    display: block;
    width: 100%;
    min-height: 100px;
    background-color: ${(props) => props.theme.palette.action.hover};
  }
`;

function PostContentPersonalMessage({
  paragraph,
  onPersonalMessageClick,
}: PostContentPersonalMessagePropsT) {
  return (
    <StyledPersonalMessageParagraph>
      <Stack spacing={2}>
        <Stack direction="row" alignItems="center">
          <Typography variant="subtitle1" sx={{ flex: 1 }}>
            개인별 메시지
          </Typography>
          <Button
            variant="text"
            color="primary"
            endIcon={<ArrowForwardIcon fontSize="medium" />}
            onClick={() =>
              onPersonalMessageClick && onPersonalMessageClick(paragraph)
            }
          >
            개인별 보기
          </Button>
        </Stack>
        <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>{paragraph.baseText}</Typography>
        <Box
          sx={
            {
              // p: 1,
              // backgroundColor: palette.action.hover,
              // borderRadius: 1,
            }
          }
        >
          <Typography variant="caption" color="textSecondary">
            개인별 메시지를 각 학생의 학부모가 볼때는 홍길동 부분이 해당 학생의
            이름으로 치환되어 보여집니다.
          </Typography>
        </Box>
      </Stack>
    </StyledPersonalMessageParagraph>
  );
}
export default PostContentPersonalMessage;
